import { isEqual } from 'lodash';

export const VENDOR_CONTRACT_LOCKED_FIELDS = new Set([
	'vendor_id',
	'project_id',
	'temperature_controlled',
	'vehicle_type_id',
	'capacity_tonnes',
	'route_id',
	'billing_type',
	'billing_subtype',
]);

export const CLIENT_CONTRACT_LOCKED_FIELDS = new Set([
	'client_id',
	'project_id',
	'temperature_controlled',
	'vehicle_type_id',
	'capacity_tonnes',
	'route_id',
	'billing_type',
	'billing_subtype',
]);

const normalize = (v) => (v === '' || v === undefined ? null : v);

export const buildChangesDiff = (current = {}, original = {}, lockedFields = new Set()) => {
	const out = {};
	Object.keys(current).forEach((key) => {
		if (lockedFields.has(key)) return;
		if (key === 'id') return;
		const a = normalize(current[key]);
		const b = normalize(original?.[key]);
		if (!isEqual(a, b)) {
			out[key] = current[key];
		}
	});
	return out;
};
